import { Formulas } from "@/common/Utils";
import { DingTalk } from "@/common/DingTalk";

let currencyFormulas = new Formulas.Formula(
  "(data.currency * data.decimals) / data.decimals",
  2
);
let weightFormulas = new Formulas.Formula("data.weight / data.unit", 2);

interface CurrencyParams {
  _currency?: string;
  decimals?: number;
  /** 是否计算并显示 `万` 或 `亿` */
  unit?: boolean;
}

export default class FilterHelper {
  /**
   * 数据格式化成金额
   * @param value
   * @param _currency
   * @param decimals
   */
  static currency(value, params: CurrencyParams = {}) {
    let { _currency, decimals, unit } = params;
    value = parseFloat(value);
    if (!isFinite(value) || (!value && value !== 0)) return "";
    decimals = decimals != null ? decimals : 2;
    if (decimals < 0) return value;
    let _unit = "";
    value = currencyFormulas.calc({
      currency: value,
      decimals: 100
    });
    if (!!unit) {
      if (value >= 100000000000) {
        value = weightFormulas.calc({
          weight: value,
          unit: 10000 * 10000
        });
        decimals = 0;
        _unit = "亿";
      } else if (value >= 10000000) {
        value = weightFormulas.calc({
          weight: value,
          unit: 10000
        });
        decimals = 0;
        _unit = "万";
      }
    }
    _currency = _currency != null || _currency != undefined ? _currency : "￥";
    // value = (Math.ceil(value * 100)) / 100
    let stringified = Math.abs(value).toFixed(decimals);
    let _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
    let i = _int.length % 3;
    let head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? "," : "") : "";
    let _float = decimals ? stringified.slice(-1 - decimals) : "";
    let sign = value < 0 ? "-" : "";
    let digitsRE = /(\d{3})(?=\d)/g;
    return (
      sign +
      _currency +
      head +
      _int.slice(i).replace(digitsRE, "$1,") +
      _float +
      _unit
    );
  }

  /**
   *
   * @param url
   */
  static urlToList(url) {
    const urllist = url.split("/").filter(i => i);
    return urllist.map((urlItem, index) => {
      return `/${urllist.slice(0, index + 1).join("/")}`;
    });
  }

  /**
   * 对 setTimeout 的封装
   * @param time
   */
  static sleep(time: number) {
    return new Promise(function(resolve, reject) {
      setTimeout(function() {
        resolve();
      }, time);
    });
  }

  /**
   * 把对象转换成用于url链接的字符串
   * @param url
   * @param params
   */
  static url2string(url: string, params: object = {}) {
    let paramsArr: string[] = [];
    params = { corpId: DingTalk.corpId, ...params };
    // params = {...FilterHelper.getLocationSearch(), ...params}
    for (const key in params) {
      params[key] &&
        paramsArr.push(`${key}=${encodeURIComponent(params[key])}`);
    }
    if (paramsArr.length > 0) {
      url = url + (url.search(/\?/g) === -1 ? "?" : "&");
      url = url + paramsArr.join("&");
    }
    // url = url.replace(".html?", ".html#/?");
    return url;
  }

  /**
   * getLocationSearch 获取 window.location.search 的参数并格式化成 object
   */
  static getLocationSearch() {
    let obj: any = {};
    let { search, hash } = window.location;
    // search = search || hash.replace("#/?corpId=", "?corpId=");
    const searchArr = decodeURIComponent(search)
      .substring(1)
      .split("&");
    for (let index = 0; index < searchArr.length; index++) {
      const element = searchArr[index].split("=");
      const key = element[0];
      const val = element[1];
      obj[key] = val;
    }
    window.baseConfig.development && console.log(obj);
    return obj;
  }
}



// WEBPACK FOOTER //
// ./src/common/Utils/FilterHelper.ts